import React from 'react';
import useStyle from './subTitle.style';
import { classNames } from '../../../../helpers/style/classNames';

export interface SubTitleProps {
  text: string;
  isBackground?: boolean;
  isBlack?: boolean;
  isDanger?: boolean;
}

export const SubTitle = ({
  text,
  isBackground,
  isBlack,
  isDanger
}: SubTitleProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root],
        [
          {
            condition: isBackground,
            classe: classes.grey
          },
          {
            condition: isDanger,
            classe: classes.danger
          }
        ]
      )}
    >
      <h4
        className={classNames(
          [classes.text],
          [
            {
              condition: isBlack && !isDanger,
              classe: classes.black
            },
            {
              condition: isDanger,
              classe: classes.dangerText
            }
          ]
        )}
      >
        {text}
      </h4>
    </div>
  );
};
